import { useEffect, useState } from "react";
import { navItems, siteMeta } from "@/mocks/site";
import { scrollToSection } from "@/pages/home/utils";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id: string) => {
    setMenuOpen(false);
    scrollToSection(id);
  };

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 w-full transition-colors duration-300 ${
        solid ? "border-b border-background-200 bg-background-50/95 backdrop-blur" : "border-b border-transparent"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-8">
        <h1 className="flex items-center">
          <a
            href="#top"
            onClick={(e) => {
              e.preventDefault();
              handleNav("top");
            }}
            className={`flex items-center gap-2.5 font-heading text-lg font-bold tracking-wide transition-colors md:text-xl ${
              solid ? "text-foreground-950" : "text-background-50"
            }`}
          >
            <span
              className={`flex h-9 w-9 items-center justify-center rounded-md border transition-colors ${
                solid ? "border-primary-300 bg-primary-500 text-background-50" : "border-background-50/40 bg-primary-500 text-background-50"
              }`}
            >
              <i className="ri-file-shield-2-line text-lg leading-none"></i>
            </span>
            <span>
              {siteMeta.name}
              <span className={`ml-2 hidden font-body text-xs font-normal tracking-normal lg:inline ${solid ? "text-foreground-500" : "text-background-50/70"}`}>
                {siteMeta.slogan}
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                handleNav(item.id);
              }}
              className={`whitespace-nowrap rounded-md px-3 py-2 font-label text-sm transition-colors ${
                solid
                  ? "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                  : "text-background-50/85 hover:bg-background-50/15 hover:text-background-50"
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleNav("contact");
            }}
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            我要投稿
          </a>
        </nav>

        <button
          type="button"
          aria-label="打开导航菜单"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border transition-colors md:hidden ${
            solid ? "border-background-300 text-foreground-900" : "border-background-50/40 text-background-50"
          }`}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-3-line"} text-xl leading-none`}></i>
        </button>
      </div>

      {menuOpen ? (
        <nav className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 md:hidden" aria-label="移动端导航">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(item.id);
                }}
                className="whitespace-nowrap rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-center font-label text-sm text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      ) : null}
    </header>
  );
}